import { render, staticRenderFns } from "./PostSroMainHome.vue?vue&type=template&id=00a05948"
import script from "./PostSroMainHome.vue?vue&type=script&lang=js"
export * from "./PostSroMainHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports